module.exports = __webpack_public_path__ + "media/images/svg/blogging-57b39e1721963e9ce097c4a0047d8653.svg";